import { React, useState } from "react";
import AppWrapper from "../AppWrapper";
import {
  Button,
  Divider,
  FormLayout,
  Page,
  Select,
  TextField,
} from "@shopify/polaris";
import { stateList } from "../../utility/GlobalVariables";
import { clabeBankName, isValidClabe, clabeDigits } from "../../utility/clabe";
import supabase from "../../supabase-client";
import { useNavigate } from "react-router-dom";

function NewServiceProvider() {
  const navigate = useNavigate();

  const [providerInfo, setProviderInfo] = useState({
    name: "",
    email: "",
    phone: "",
    contact_name: "",
    street_1: "",
    street_2: "",
    city: "",
    cp: "",
    state: "Nuevo León",
    rfc: "",
    banco: null,
    clabe: "",
    is_broker: false,
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (value, id) => {
    let newValue = value;
    if (["rfc"].includes(id)) {
      newValue = newValue.toUpperCase();
    }
    setProviderInfo({ ...providerInfo, [id]: newValue });
  };

  const isReadyToSave = () => {
    return Object.values(providerInfo).some((v) => v === "");
  };

  const handleSave = async () => {
    setIsLoading(true);
    const { data, error } = await supabase
      .from("service_providers")
      .insert({ ...providerInfo, banco: clabeBankName(providerInfo.clabe) })
      .select("id")
      .single();
    if (error) {
      setIsLoading(false);
      return;
    }

    // Create default location with the same contact/address info
    await supabase.from("provider_locations").insert({
      provider_id: data.id,
      label: "Principal",
      contact_name: providerInfo.contact_name,
      email: providerInfo.email,
      phone: providerInfo.phone,
      street_1: providerInfo.street_1,
      street_2: providerInfo.street_2,
      city: providerInfo.city,
      cp: providerInfo.cp,
      state: providerInfo.state,
      is_default: true,
    });

    navigate("/service_providers");
  };

  return (
    <AppWrapper>
      <Page
        title="Crear Proveedor"
        primaryAction={
          <Button
            disabled={isReadyToSave()}
            onClick={handleSave}
            loading={isLoading}
          >
            Guardar
          </Button>
        }
        backAction={{ url: "/service_providers" }}
      >
        <FormLayout>
          <FormLayout.Group>
            <TextField
              label="Razon Social"
              requiredIndicator
              value={providerInfo.name}
              id="name"
              onChange={handleInputChange}
            />
            <TextField
              label="RFC"
              requiredIndicator
              value={providerInfo.rfc}
              id="rfc"
              onChange={handleInputChange}
            />
            <Select
              label="Es Broker?"
              options={[
                { label: "No", value: false },
                { label: "Si", value: true },
              ]}
              value={providerInfo.is_broker}
              id="is_broker"
              onChange={handleInputChange}
            />
          </FormLayout.Group>
          <Divider />
          <FormLayout.Group>
            <TextField
              label="Nombre de Contacto"
              requiredIndicator
              value={providerInfo.contact_name}
              id="contact_name"
              onChange={handleInputChange}
            />
            <TextField
              label="Correo"
              requiredIndicator
              value={providerInfo.email}
              id="email"
              onChange={handleInputChange}
            />
            <TextField
              label="Telefono"
              requiredIndicator
              value={providerInfo.phone}
              id="phone"
              onChange={handleInputChange}
            />
          </FormLayout.Group>
          <Divider />
          <FormLayout.Group>
            <TextField
              label="Calle y Numero"
              requiredIndicator
              value={providerInfo.street_1}
              id="street_1"
              onChange={handleInputChange}
            />
            <TextField
              label="Colonia"
              requiredIndicator
              value={providerInfo.street_2}
              id="street_2"
              onChange={handleInputChange}
            />
            <TextField
              label="Ciudad"
              requiredIndicator
              value={providerInfo.city}
              id="city"
              onChange={handleInputChange}
            />
            <TextField
              label="Codigo Postal"
              requiredIndicator
              value={providerInfo.cp}
              id="cp"
              onChange={handleInputChange}
            />
            <Select
              label="Estado"
              requiredIndicator
              value={providerInfo.state}
              id="state"
              onChange={handleInputChange}
              options={stateList}
            />
          </FormLayout.Group>
          <Divider />
          <FormLayout.Group>
            <TextField
              label="Banco"
              value={clabeBankName(providerInfo.clabe) || "—"}
              disabled
              helpText="Se deduce de la CLABE; se confirma al verificar la cuenta."
            />

            <TextField
              label="Clabe Interbancaria"
              requiredIndicator
              value={providerInfo.clabe}
              id="clabe"
              onChange={handleInputChange}
              error={
                providerInfo.clabe && clabeDigits(providerInfo.clabe).length === 18 &&
                !isValidClabe(providerInfo.clabe)
                  ? "La CLABE no pasa el dígito verificador — revisa que esté bien escrita."
                  : undefined
              }
            />
          </FormLayout.Group>
        </FormLayout>
      </Page>
    </AppWrapper>
  );
}

export default NewServiceProvider;
